module.exports = __webpack_public_path__ + "img/EducationalGroupTransfers.3bda192d.svg";